<template>
  <v-container fluid class="pa-4">
    <div class="d-flex align-center mb-3">
      <h3 class="text-h6 font-weight-medium">Rubros del cuestionario</h3>
      <v-spacer />
      <v-btn color="primary" small @click="openCreateRubro">
        <v-icon left small>mdi-plus</v-icon> Nuevo rubro
      </v-btn>
    </div>

    <v-card v-if="loading" class="pa-8 text-center">
      <v-progress-circular indeterminate />
    </v-card>

    <v-card v-else>
      <v-list>
        <v-list-item
            v-for="rubro in rubros"
            :key="rubro._id"
            :to="`/sac/admin/config/rubro/${rubro._id}`"
            link
        >
            <v-list-item-avatar>
                <v-icon :color="rubro.isProfile ? 'grey' : 'primary'">
                    {{ rubro.isProfile ? 'mdi-account-outline' : 'mdi-folder-outline' }}
                </v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                    {{ rubro.name }}
                    <v-chip x-small class="ml-2">{{ rubro.key }}</v-chip>
                    <v-chip v-if="rubro.isProfile" x-small color="grey" class="ml-1">Perfil</v-chip>
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ (rubro.sections || []).length }} secciones ·
                    {{ countQuestions(rubro) }} preguntas
                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
                <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>

    <!-- Dialog crear rubro -->
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title>Crear rubro</v-card-title>
        <v-card-text>
          <v-text-field v-model="form.name" label="Nombre" outlined dense />
          <v-text-field v-model="form.description" label="Descripción" outlined dense class="mt-2" />
          <v-text-field v-model.number="form.order" type="number" label="Orden" outlined dense class="mt-2" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="saving" @click="saveRubro">Crear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-alert type="error" v-if="error" class="mt-3" dismissible @input="error = null">
      {{ error }}
    </v-alert>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex';
import { listRubros, createRubro } from '../../api/sac';

export default {
    name: 'SacConfig',
    data() {
        return {
            loading: true,
            rubros: [],
            dialog: false,
            saving: false,
            error: null,
            form: { name: '', description: '', order: 0 },
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        ...mapMutations('notification', ['show']),
        async load() {
            this.loading = true;
            this.error = null;
            try {
                const r = await listRubros();
                this.rubros = r.rubros || [];
            } catch (e) {
                this.error = e?.response?.data?.error?.message || e?.response?.data?.message || e.message || 'No se pudieron cargar los rubros';
                this.show({ text: this.error, color: 'error' });
            } finally {
                this.loading = false;
            }
        },
        countQuestions(r) {
            return (r.sections || []).reduce((acc, s) => acc + (s.questions?.length || 0), 0);
        },
        openCreateRubro() {
            this.form = { name: '', description: '', order: this.rubros.length };
            this.dialog = true;
        },
        async saveRubro() {
            this.saving = true;
            try {
                await createRubro(this.form);
                this.dialog = false;
                await this.load();
                this.show({ text: 'Rubro creado correctamente', color: 'success' });
            } catch (e) {
                this.error = e?.response?.data?.error?.message || e?.response?.data?.message || e.message || 'No se pudo crear el rubro';
                this.show({ text: this.error, color: 'error' });
            } finally {
                this.saving = false;
            }
        },
    },
};
</script>
